export const BASE_URL = "https://mern-travel-booking-api.onrender.com/api/v1";
